import { AGENT } from "../../../Services/Endpoint"
import { Agent } from "../../Types/Agent"
import { MultiAgent } from "../../Types/MultiAgent"
import { WorkflowListItem } from "../../../Services/WorkflowService"


export function isOnlyAlphabets(value: string) {
  return new RegExp(/^[A-Za-z\s]+$/).test(value)
}

export function isOnlyNumbers(value: string) {
  return new RegExp(/^[0-9]+$/).test(value)
}
export function isOnlyAlphabetsNumbers(value: string) {
  return new RegExp(/^[A-Za-z0-9 .,_-]+$/).test(value.trim());
}

export function isWebsiteAddress(value: string) {
  return new RegExp(/^(https?:\/\/(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+|[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+)(\/[a-zA-Z0-9-._~:/?#[\]@!$&'()*+,;=%]*)?$/).test(value)
}
export function isYouTubeUrl(value: string) {
  return new RegExp(/^(https?\:\/\/)?((www\.)?youtube\.com|youtu\.be)\/.+$/).test(value)
}

export function normalizeUrl(url: string) {
  // Create a URL object to handle the URL parsing
  const urlObject = new URL(url);

  // Normalize by returning hostname and pathname in lowercase
  return `${urlObject.hostname}`.toLowerCase();
}


export function formatDate(datetime: string) {
  const date = new Date(datetime);


  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  };
  const formattedDate = date.toLocaleString(undefined, options);
  return formattedDate
}

export function normalizeMarkdown(content: string): string {
  return content
    .replace(/^--\s*/gm, '- ')                  // Replace malformed unordered list
    .replace(/^(\d+)\.(\S)/gm, '$1. $2')         // Fix numbered list
    .replace(/^(\*|\+)\s*/gm, '- ')              // Normalize other bullets
    .replace(/^(#{1,6})([^\s#])/gm, '$1 $2')     // Add space in headings
    .replace(/\n{3,}/g, '\n\n')                  // Collapse triple newlines
    .trim();
}

export function capitalizeFirstLetter(str: string) {
  if (!str) return "";
  var newStr = str.charAt(0).toUpperCase() + str.slice(1);
  newStr = newStr.replace(/[^a-zA-Z0-9]+/g, ' ').trim();
  return newStr;
}

/**
 * Decodes HTML entities in a string (e.g., &quot;, &#39;, etc.)
 * Uses browser's textarea element for decoding.
 */
export function decodeHTMLEntities(text: string): string {
  if (!text) return "";
  const txt = document.createElement("textarea");
  txt.innerHTML = text;
  return txt.value;
}




export function generateIframeBubbleCode(
  RedirectUrl: string,
  agentOrMultiAgentOrWorkflow: Agent | MultiAgent | WorkflowListItem,
  path: string
) {
  // Use agentOrMultiAgentOrWorkflow properties as needed
  // Example: agentOrMultiAgentOrWorkflow.id, agentOrMultiAgentOrWorkflow.name, etc.

  const url = `${RedirectUrl}${path}/${agentOrMultiAgentOrWorkflow.id}/PLACE YOUR_API_KEY`

  // Check if it's an agent, multi-agent, or workflow and get the appropriate metadata
  const isMultiAgent = 'team_metadata' in agentOrMultiAgentOrWorkflow;
  const isWorkflow = (agentOrMultiAgentOrWorkflow as any).is_workflow === true;
  const metadata = isMultiAgent
    ? (agentOrMultiAgentOrWorkflow as any).team_metadata
    : isWorkflow
      ? undefined
      : (agentOrMultiAgentOrWorkflow as any).agent_metadata;

  // Use the appropriate JavaScript file based on the type
  const jsFileName = isMultiAgent ? 'embed-iframe-multi-agent.js' : isWorkflow ? 'embed-iframe-workflow.js' : 'embed-iframe.js';

  // Use the correct endpoint based on the type
  const endpoint = isWorkflow ? AGENT.replace('/agents', '/workflows') : AGENT;

  const userContextScript =
    metadata?.user_context_awareness
      ? `
<script>
  ZEAIQ_USER_DATA = {
    id: "123",
    name: "John Doe",
    email: "john.doe@example.com",
  }
</script>
    `
      : "";

  return `<script src="${endpoint}/${agentOrMultiAgentOrWorkflow.id}/PLACE YOUR_API_KEY/${jsFileName}"></script>
  ${userContextScript}`;
}



//  old

export function generateIframeCode(RedirectUrl: string, token: string, agentId: string) {
  const url = `${RedirectUrl}iframe/${token}/${agentId}`
  return `<iframe
     src=${url}
      width="100%"
      style="height: 100%; min-height: 700px"
      frameBorder="0"
    ></iframe>`;


}




